import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { FUEL_OPTIONS } from '../../../helpers/inspectionForm';
import s from '../Inspection.css';

// Fuel gauge in five steps (Reserve, 1/4, 1/2, 3/4, Full). A radio group: keyboard and screen reader friendly.
export function FuelLevelSelector({ value, onChange, disabled, name, intl, invalid }) {
  const { formatMessage } = intl;
  if (disabled) {
    const current = FUEL_OPTIONS.find((option) => option.value === value);
    return <p className={s.readOnlyValue}>{current ? formatMessage(messages[current.labelKey]) : '-'}</p>;
  }
  return (
    <div role="radiogroup" aria-label={formatMessage(messages.inspFuelTitle)} aria-invalid={invalid ? 'true' : undefined} className={s.fuelRow}>
      {FUEL_OPTIONS.map((option) => {
        const selected = option.value === value;
        return (
          <label key={option.value} className={cx(s.optionLabel, s.fuelLabel, selected && s.optionLabelSelected)}>
            <input
              type="radio"
              className={s.optionInput}
              name={name}
              value={option.value}
              checked={selected}
              onChange={() => onChange(option.value)}
            />
            <span className={s.optionBody}><span className={s.optionText}>{formatMessage(messages[option.labelKey])}</span></span>
          </label>
        );
      })}
    </div>
  );
}

FuelLevelSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  name: PropTypes.string
};
FuelLevelSelector.defaultProps = { value: '', onChange: () => {}, disabled: false, name: 'fuelLevel' };

export default injectIntl(withStyles(s)(FuelLevelSelector));
